import audio from '@/scripts/audio';
import eventHub from '@/scripts/eventHub';
// import gsap from 'gsap';
import {
  AnimatedSprite,
  Loader,
  Point,
  Sprite,
} from 'pixi.js';
import state from '../state';
import ticker from '../ticker';
import { hitTest } from '../utils';
import vars from '../vars';
import Actor from './Actor';

class Hole extends Actor {
  constructor(parent, player, type = 'normal') {
    super(parent);
    this.player = player;
    this.type = type;
    this.hitted = false;

    this.fall = new AnimatedSprite(Object.values(Loader.shared.resources['sprites/FALL'].textures));
    this.fall.loop = false;
    this.fall.renderable = false;
    this.fall.animationSpeed = 0.4;

    this.frameHandler = () => { this.frame(); };

    this.resize();
    this.sprite.addChild(this.fall);
    this.parent.addChild(this.sprite);

    ticker.add(this.frameHandler);
  }

  resize() {
    switch (this.type) {
      case 'normal':
        this.sprite = new AnimatedSprite(
          Object.values(
            Loader.shared.resources['sprites/HOLE_SMALL'].spritesheet.textures,
          ),
        );
        this.sprite.anchor = new Point(0.5, 0.5);
        break;
      case 'mid':
        this.sprite = new AnimatedSprite(
          Object.values(
            Loader.shared.resources['sprites/HOLE_MID'].spritesheet.textures,
          ),
        );
        this.sprite.anchor = new Point(0.5, 0.5);
        break;
      case 'big':
        this.sprite = new AnimatedSprite(
          Object.values(
            Loader.shared.resources['sprites/HOLE_BIG'].spritesheet.textures,
          ),
        );
        this.sprite.anchor = new Point(0.5, 0.5);
        break;
      case 'full':
        this.sprite = new Sprite(Loader.shared.resources['textures/RIVER_BACK'].texture);
        this.sprite.anchor = new Point(0.0625, 0);
        this.sprite.width = vars.layout.GRID_UNIT * 8;
        this.waves = new AnimatedSprite(Object.values(Loader.shared.resources['sprites/RIVER'].textures));
        this.submarine = new AnimatedSprite(Object.values(Loader.shared.resources['sprites/SUBMARINE'].textures));
        this.waves.position.x -= this.waves.width * 0.0625;
        this.submarine.position.x -= this.submarine.width * 0.0625;
        this.sprite.addChild(this.submarine);
        this.sprite.addChild(this.waves);
        this.submarine.animationSpeed = 0.5;
        this.waves.animationSpeed = 0.5;
        this.submarine.loop = false;
        setTimeout(() => this.submarine.play(), 1000);
        this.waves.play();
        break;

      default:
        break;
    }

    this.fall.zIndex = 7;
    this.fall.anchor = new Point(0.5, 0.5);
  }

  frame() {
    // Move the frame if the hole is animated
    if (['normal', 'mid', 'big'].includes(this.type)) {
      const { top } = this.sprite.getBounds();
      const positionPercentage = top / vars.layout.FRAME_HEIGHT;
      const frame = parseInt(positionPercentage * this.sprite.totalFrames, 10);
      this.sprite.gotoAndStop(frame);
    }

    if (
      hitTest(this.sprite, this.player.sprite, this.type === 'big' ? 40 : 10)
      && !this.player.jumping
      && !this.player.invincible
      && !this.player.isButterfly
      && !this.hitted
    ) {
      this.hitted = true;
      this.fall.renderable = true;
      this.fall.play();
      this.player.tail.sprite.renderable = false;
      eventHub.$emit('shake');
      audio.play('gameover');
      this.fall.onComplete = () => {
        state.gameover = true;
        eventHub.$emit('gameover');
      };
    }
  }

  destroy() {
    ticker.remove(this.frameHandler);
  }
}

export default Hole;
